import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const PageTitle = ({ children, className }) => {
  return <h1 className={`${className} ${styles['page-title']}`}>{children}</h1>;
};

PageTitle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  className: PropTypes.string,
};

export default PageTitle;



// WEBPACK FOOTER //
// ./src/common/components/PageTitle/index.js